import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    questionsGridContainer: {
        margin: '0px 16px',
        height: 'calc(100% - 390px)'
    },
});
